export const css = {
    root: 'Ff_tfY3s',
    tabTitle: '_2eYS0Ixs',
    titleOpen: '_28FmLXZ3',
    titleClosed: '_2DSLkOqr',
    ' _key': 'dashboard-widgets/tabcontainer'
};
export default css;
